const ServiceOverview = () =>
  import(
    /* webpackChunkName: "ServicesViews" */ '../views/services/ServiceOverview.vue'
    );
const ServiceDetails = () =>
  import(
    /* webpackChunkName: "ServicesViews" */ '../views/services/ServiceDetails.vue'
    );

export const routeServices = [
  {
    path: 'services',
    name: 'ServiceOverview',
    component: ServiceOverview,
    meta: {
      title: 'Service Store'
    }
  },
  {
    path: 'services/:id',
    name: 'ServiceDetails',
    component: ServiceDetails,
    meta: {
      title: 'Service'
    }
  }
];
